"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInstalledIntegrations = exports.FetchInstalled = exports.FetchInstalledActionTypes = exports.IntegrationsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var IntegrationsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_INSTALLED_INTEGRATIONS: null
}, 'integrations');
exports.IntegrationsActionTypes = IntegrationsActionTypes;
var FetchInstalledActionTypes = (0, _actions.createRequestTypes)(IntegrationsActionTypes.FETCH_INSTALLED_INTEGRATIONS);
exports.FetchInstalledActionTypes = FetchInstalledActionTypes;
var FetchInstalled = (0, _actions.createRequestActions)(FetchInstalledActionTypes);
exports.FetchInstalled = FetchInstalled;
var fetchInstalledIntegrations = (0, _fluxActions.createAction)(IntegrationsActionTypes.FETCH_INSTALLED_INTEGRATIONS);
exports.fetchInstalledIntegrations = fetchInstalledIntegrations;